import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import './assets/fonts/fonts.css'; // Descomente quando adicionar a fonte

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);